import { createCompanyAreaContext } from './shared_company_area_context'

export const REBUILD_COMPANY_AREA_CONTEXT_STORAGE_KEY = 'hapisumu.rebuildCompanyAreaContext'

export const {
  initArchiveAreaContext: initRebuildCompanyArchiveAreaContext,
  applyDetailAreaContext: applyRebuildCompanyDetailAreaContext,
} = createCompanyAreaContext({
  storageKey: REBUILD_COMPANY_AREA_CONTEXT_STORAGE_KEY,
  attributePrefix: 'rebuild-company',
})
